import { useForm } from '@mantine/form';

import { TransitViewEditGoodsItemFormValues } from './validateTransitViewEditGoodsItemForm';

export const useTransitViewEditGoodsItemFormInitializer = ({ houseConsignmentIdx, goodsItemIdx, form, onSave, onHide }) => {
  const houseConsignment = form?.values?.Consignment.HouseConsignment[houseConsignmentIdx];
  const goodsItem = houseConsignment?.ConsignmentItem?.[goodsItemIdx];

  const goodsItemForm = useForm<TransitViewEditGoodsItemFormValues>({
    initialValues: {
      isMissing: goodsItem?.isMissing || false,
      receivedFromUnloadPermission: goodsItem?.receivedFromUnloadPermission || false,
      goodsItemNumber: goodsItem?.goodsItemNumber || '',
      declarationGoodsItemNumber: goodsItem?.declarationGoodsItemNumber || '',
      declarationType: goodsItem?.declarationType || '',
      countryOfDispatch: goodsItem?.countryOfDispatch || '',
      countryOfDestination: goodsItem?.countryOfDestination || '',
      referenceNumberUCR: goodsItem?.referenceNumberUCR || '',
      Commodity: {
        descriptionOfGoods: goodsItem?.Commodity?.descriptionOfGoods || '',
        CUSCode: goodsItem?.Commodity?.CUSCode || '',
        DangerousGoods: (goodsItem?.Commodity?.DangerousGoods ?? []).map((dangerousGoods) => ({
          UNNumber: dangerousGoods.UNNumber || '',
        })),
        CommodityCode: {
          hsCode: goodsItem?.Commodity?.CommodityCode?.hsCode || '',
          initialAmountToPayForDuties: goodsItem?.Commodity?.CommodityCode?.initialAmountToPayForDuties || '',
          initialAmountToPayForVat: goodsItem?.Commodity?.CommodityCode?.initialAmountToPayForVat || '',
        },
        GoodsMeasure: {
          grossMass: goodsItem?.Commodity?.GoodsMeasure?.grossMass || '',
          netMass: goodsItem?.Commodity?.GoodsMeasure?.netMass || '',
          supplementaryUnits: goodsItem?.Commodity?.GoodsMeasure?.supplementaryUnits || '',
        },
      },
      Packaging: (goodsItem?.Packaging ?? []).map((packaging) => ({
        typeOfPackages: packaging.typeOfPackages || '',
        numberOfPackages: packaging.numberOfPackages || '',
        shippingMarks: packaging.shippingMarks || '',
      })),
      AdditionalSupplyChainActor: (goodsItem?.AdditionalSupplyChainActor ?? []).map((additionalSupplyChainActor) => ({
        role: additionalSupplyChainActor.role || '',
        identificationNumber: additionalSupplyChainActor.identificationNumber || '',
      })),
      documents: {
        PreviousDocument: (goodsItem?.PreviousDocument || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
          goodsItemNumber: previousDocument.goodsItemNumber || '',
          typeOfPackages: previousDocument.typeOfPackages || '',
          numberOfPackages: previousDocument.numberOfPackages || '',
          measurementUnitAndQualifier: previousDocument.measurementUnitAndQualifier || '',
          quantity: previousDocument.quantity || '',
          complementOfInformation: previousDocument.complementOfInformation || '',
        })),
        SupportingDocument: (goodsItem?.SupportingDocument || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
          documentLineItemNumber: previousDocument.documentLineItemNumber || '',
          complementOfInformation: previousDocument.complementOfInformation || '',
        })),
        AdditionalReference: (goodsItem?.AdditionalReference || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
        })),
        AdditionalInformation: (goodsItem?.AdditionalInformation || []).map((previousDocument) => ({
          code: previousDocument.code || '',
          text: previousDocument.text || '',
        })),
      },
    },
  });

  const onSubmit = async () => {
    const values = goodsItemForm.values;
    const data = {
      ...values,
      ...values.documents,
      documents: undefined,
    };

    onSave(data);
    onHide();
  };

  return { goodsItemForm, onSubmit, houseConsignment };
};
